/**
 * When Clips feed is active and a video is playing (not paused),
 * the bottom nav bar is hidden. ClipsFeedPage sets this; BottomBar reads it.
 */
import {
  createContext,
  useCallback,
  useContext,
  useState,
  type ReactNode,
} from 'react'

type ClipsFeedFullscreenContextValue = {
  hideBottomBar: boolean
  setHideBottomBar: (hide: boolean) => void
}

const ClipsFeedFullscreenContext =
  createContext<ClipsFeedFullscreenContextValue | null>(null)

export function useClipsFeedFullscreen(): ClipsFeedFullscreenContextValue {
  const ctx = useContext(ClipsFeedFullscreenContext)
  if (!ctx) {
    return {
      hideBottomBar: false,
      setHideBottomBar: () => {},
    }
  }
  return ctx
}

export function ClipsFeedFullscreenProvider({
  children,
}: {
  children: ReactNode
}) {
  const [hideBottomBar, setHideBottomBarState] = useState(false)
  const setHideBottomBar = useCallback((hide: boolean) => {
    setHideBottomBarState(hide)
  }, [])
  return (
    <ClipsFeedFullscreenContext.Provider
      value={{hideBottomBar, setHideBottomBar}}>
      {children}
    </ClipsFeedFullscreenContext.Provider>
  )
}
